export default "__VITE_ASSET__VOQxs6Vh__"